import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';

/**
 * The icon style to ask the OS status bar for on a native platform.
 *
 * The plugin names a style after the background it is meant for: Style.Dark
 * gives light icons (for a dark bar) and Style.Light gives dark icons.
 *
 * MUS-578: on Android the bar sits on black on every OS version (the status bar
 * colour up to Android 14, the window background behind the transparent bar
 * from Android 15), so dark icons were close to unreadable there. iOS keeps the
 * style it has always asked for.
 */
export const statusBarStyleFor = (platform: string): Style =>
  platform === 'android' ? Style.Dark : Style.Light;

/**
 * Keep the OS status bar visible, lay the webview out below it where the OS
 * still allows that, and ask for readable icons.
 *
 * MUS-577: Android 15+ ignores the overlay request (edge to edge is enforced);
 * there the native shell keeps the webview clear of the bars instead, see
 * android.adjustMarginsForEdgeToEdge in capacitor.config.ts.
 */
export async function configureNativeStatusBar(): Promise<void> {
  await StatusBar.setOverlaysWebView({ overlay: false });
  await StatusBar.setStyle({ style: statusBarStyleFor(Capacitor.getPlatform()) });
}
